import ReactImgix from "./react-imgix";
export default ReactImgix;